<template>
	<div class="ui card subjectCard">
		<div class="content">
			<a ref="zoomButton" class="ui tiny corner left label" @click="zoom"><i class="zoom icon"></i></a>
			<div class="header">
				<div class="ui massic image subjectAvatar">
					<img :src="subject.cdn_url" />
				</div>
				<div class="content">{{ name }}</div>
			</div>
			<div class="description">{{ teacherLabel }}: {{ teacher }}</div>
			<div class="description">Grade: {{ grade }}</div>
			<div class="description" v-if="email">Email: {{ email }}</div>
			<div class="description" v-if="phoneNumber">Phone Number: {{ phoneNumber }}</div>
			<div class="description" v-if="studentId">Student ID: {{ studentId }}</div>
		</div>
		<div class="ui two bottom attached buttons">
			<div class="ui deny button" @click="deny" v-if="!viewingDenied"><i class="thumbs down icon"></i> Delete</div>
			<div class="ui primary button" @click="approve"><i class="thumbs up icon"></i> Approve</div>
		</div>
		<div class="ui inverted dimmer" :class="{ active: loading }"><div class="ui loader"></div></div>
	</div>
</template>

<script>
export default {
	props: ['subject', 'project', 'deniedSubjectAlbum', 'viewingDenied'],
	data: function() {
		return {
			loading: false,
			subjectToMergeWith: null,
			fieldLabelMap: null
		};
	},
	computed: {
		name: function() {
			return this.firstName + ' ' + this.lastName;
		},
		firstName: function() {
			return this.getPropFromTag('First Name');
		},
		lastName: function() {
			return this.getPropFromTag('Last Name');
		},
		teacher: function() {
			return this.getPropFromTag('Teacher');
		},
		teacherLabel: function() {
			if(this.project.groupBy && this.project.groupBy.indexOf('Home Room') === 0) {
				return 'Home Room';
			} else {
				return 'Teacher';
			}
		},
		grade: function() {
			return this.getPropFromTag('Grade');
		},
		email: function() {
			return this.hasField('Email') && this.getPropFromTag('Email');
		},
		phoneNumber: function() {
			return this.hasField('Phone Number') && this.getPropFromTag('Phone Number');
		},
		studentId: function() {
			return this.hasField('Student ID') && this.getPropFromTag('Student ID');
		},
		matchedSubjects: function() {
			return this.getMatchedSubjects(this.teacher, this.grade);
		}
	},
	methods: {
		getMatchedSubjects: function(teacher, grade) {
			var firstName = this.firstName;
			var lastName = this.lastName;
			var studentId = this.studentId;

			var subjects = $.merge([], this.project.subjects || []);
			$.merge(subjects, this.project.placeholderSubjects || []);

			var me = this;
			var dmp = new window.diff_match_patch();
			var MAX_CHARS_DIFF = 1;
			return subjects.filter(function(mySubject) {
				var myFirstName = mySubject['First Name'];
				var myLastName = mySubject['Last Name'];
				var myTeacher = mySubject['Teacher'];
				var myGrade = mySubject['Grade'];

				return (
						me.getStrDiff(dmp, firstName, myFirstName) <= MAX_CHARS_DIFF && me.getStrDiff(dmp, lastName, myLastName) <= MAX_CHARS_DIFF &&
						me.getStrDiff(dmp, teacher, myTeacher) <= MAX_CHARS_DIFF && me.getStrDiff(dmp, grade, myGrade) <= MAX_CHARS_DIFF
					) ||
					(
						studentId && mySubject['Student ID'] && $.trim(studentId.toLowerCase()) == $.trim(mySubject['Student ID'].toLowerCase())
					);
			});
		},
		getStrDiff: function(dmp, a, b) {
			a = $.trim((a || '').toLowerCase());
			b = $.trim((b || '').toLowerCase());

			if(a == b) {
				return 0;
			} else {
				var diffs = dmp.diff_main(a, b);
				var charsDifferent = diffs.reduce(function(total, diff) {
					return total + Math.abs(diff[0]) * diff[1].length;
				}, 0);

				// console.log(a + ' vs ' + b + ' => ' + charsDifferent, diffs);
				return charsDifferent;
			}
		},
		getPropFromTag: function(name) {
			for(var i = 0; i < this.subject.tags.length; i++) {
				var tag = this.subject.tags[i];
				var search = name + ': ';
				var index = tag.indexOf(search);
				if(index !== -1) {
					return tag.substr(index + search.length);
				}
			}

			return null;
		},
		hasField: function(name) {
			var fieldLabelMap = this.getFieldLabelMap();
			return !!fieldLabelMap[name];
		},
		approve: function(options) {
			options = $.extend(true, {
				skipFixingProperties: false
			}, options);

			var promptForFixing = [];
			var fieldValues = this.getFieldValues();
			for(var id in fieldValues) {
				var values = fieldValues[id];
				var value = this[id.toLowerCase()];
				if(values.length && values.indexOf(value) === -1) {
					promptForFixing.push(id);
				}
			}

			var matchingSubjects = this.matchedSubjects;

			var needsToCrop = false;
			if(this.subject.width && this.subject.height && !(this.subject.photo_crops || []).length) {
				var ratio = 0.8;
				if(!$.isWithinDiff(this.subject.width / this.subject.height, ratio, 0.01) && !$.isWithinDiff(this.subject.height / this.subject.width, ratio, 0.01)) {
					needsToCrop = true;
				}
			}

			if((promptForFixing.length || matchingSubjects.length) && !options.skipFixingProperties) {
				this.promptForFixing(promptForFixing, fieldValues, matchingSubjects);
			} else if(needsToCrop) {
				var dummySubject = {
					photo: this.subject.id,
					yearbookPhoto: this.subject
				};

				var me = this;
				var dialog = $.SubjectImageDialog({
					subject: dummySubject,
					onBeforeSave: function() {
						me.loading = true;
					},
					onAfterSave: function() {
						me.loading = false;
					},
					onSaveCrop: function(crop) {
						if(me.subject.photo_crops) {
							me.subject.photo_crops.push(crop);
						} else {
							me.subject.photo_crops = [crop];
						}

						me.finishApprove();
					},
					onSavePhotoVersion: function(newPhoto) {
						$.extend(true, me.subject, newPhoto);
					}
				});
				dialog.show();
			} else {
				this.finishApprove();
			}
		},
		getFieldValues: function() {
			var fieldValues = {};
			fieldValues[this.teacherLabel] = [];
			fieldValues.Grade = [];

			(this.project.subjects || []).forEach(function(subject) {
				for(var id in fieldValues) {
					var value = subject[id];
					if(value && fieldValues[id].indexOf(value) === -1) {
						fieldValues[id].push(value);
					}
				}
			});

			for(var id in fieldValues) {
				fieldValues[id].caseInsensitiveSort();
			}

			return fieldValues;
		},
		promptForFixing: function(promptForFixing, fieldValues, matchingSubjects) {
			var me = this;
			var settings = promptForFixing.map(function(fieldId) {
				var defaultValue = me[fieldId.toLowerCase()];

				var dmp = new window.diff_match_patch();
				var closestMatch = null, closestMatchDiff = 2;
				fieldValues[fieldId].forEach(function(possibleMatch) {
					var diff = me.getStrDiff(dmp, defaultValue, possibleMatch);
					if(diff < closestMatchDiff) {
						closestMatch = possibleMatch;
						closestMatchDiff = diff;
					}
				});

				return {
					id: fieldId,
					description: fieldId,
					defaultValue: closestMatch || defaultValue,
					type: 'dropdown',
					options: fieldValues[fieldId],
					dropdownSettings: {
						allowAdditions: true,
						forceSelection: false
					},
					onChange: function(newValue, unknown, item) {
						var setting = item.setting;
						if(me[setting.id.toLowerCase()] == newValue) {
							return;
						}

						var teacher = me.teacher;
						var grade = me.grade;
						if(setting.id === 'Teacher') {
							teacher = newValue;
						} else if(setting.id === 'Grade') {
							grade = newValue;
						}

						var newMatchingSubjects = me.getMatchedSubjects(teacher, grade);
						dialog[0].settingsForm.removeSettingByName('matchSubject');
						if(newMatchingSubjects.length) {
							dialog[0].settingsForm.addSetting(me.createMatchingSubjectsSetting(newMatchingSubjects));
						}
					}
				};
			});

			if(matchingSubjects.length) {
				settings.push(this.createMatchingSubjectsSetting(matchingSubjects));
			}

			var dialog = $.SettingsBuilderDialog(settings, {
				title: 'Do you want to fix or match anything?',
				onSettingsApplied: function(settings) {
					for(var fieldId in settings) {
						if(fieldId === 'matchSubject') {
							if(settings[fieldId] && settings[fieldId] !== 'none') {
								me.subjectToMergeWith = me.matchedSubjects.filter(function(subject) {
									return subject.id == settings[fieldId];
								})[0];
							}
							continue;
						}

						for(var i = 0; i < me.subject.tags.length; i++) {
							if(me.subject.tags[i].indexOf(fieldId + ': ') !== -1) {
								Vue.set(me.subject.tags, i, fieldId + ': ' + settings[fieldId]);
							}
						}
					}

					me.approve({
						skipFixingProperties: true
					});
				}
			});
		},
		createMatchingSubjectsSetting: function(matchingSubjects) {
			matchingSubjects = $.merge([], matchingSubjects);
			matchingSubjects.push({
				id: 'none'
			});

			return {
				id: 'matchSubject',
				type: 'radio',
				description: 'Merge with subject',
				options: matchingSubjects,
				label: function(subject) {
					if(subject.id === 'none') {
						return 'None';
					}

					return 'Name: ' + subject['First Name'] + ' ' + subject['Last Name'] + ', Teacher: ' + subject['Teacher'] + ', Grade: ' + subject['Grade'];
				},
				itemId: 'id',
				defaultValue: 'none'
			};
		},
		finishApprove: function() {
			if(this.subjectToMergeWith) {
				this.mergeWithSubject(this.subjectToMergeWith);
			} else {
				this.createSubject();
			}
		},
		mergeWithSubject: function(subjectToMergeWith) {
			var me = this;
			this.loading = true;

			var fieldLabelMap = this.getFieldLabelMap();
			var plicProperties = {};
			if(this.studentId && fieldLabelMap['Student ID'] && !subjectToMergeWith['Student ID']) {
				plicProperties[fieldLabelMap['Student ID']] = this.studentId;
			}
			if(this.email && fieldLabelMap['Email']) {
				plicProperties[fieldLabelMap['Email']] = this.email;
			}
			if(this.phoneNumber && fieldLabelMap['Phone Number']) {
				plicProperties[fieldLabelMap['Phone Number']] = this.phoneNumber;
			}
			
			if($.getObjectCount(plicProperties) > 0) {
				$.plicAPI({
					method: 'subjects/' + subjectToMergeWith.id,
					params: {
						subject: {
							properties: plicProperties,
							merge_properties: true
						}
					},
					type: 'PUT',
					success: function(data) {
						me.mergeWithSubjectPhoto(subjectToMergeWith);
					},
					error: function () {
						$.Alert('Error', 'Failed to update subject');
						me.loading = false;
					}
				});
			} else {
				this.mergeWithSubjectPhoto(subjectToMergeWith);
			}
		},
		mergeWithSubjectPhoto: function(subjectToMergeWith) {
			var me = this;
			$.plicAPI({
				method: 'subject-photo-assignments',
				type: 'POST',
				params: {
					subject_photo_assignment: {
						subject_id: subjectToMergeWith.id,
						photo_id: this.subject.id
					},
					is_primary: true
				},
				success: function(data) {
					me.moveSubjectPose();
				},
				error: function () {
					$.Alert('Error', 'Failed to add new subject');
					me.loading = false;
				}
			});
		},
		createSubject: function() {
			this.loading = true;

			var fieldLabelMap = this.getFieldLabelMap();
			var properties = {};
			properties[fieldLabelMap['First Name']] = this.firstName;
			properties[fieldLabelMap['Last Name']] = this.lastName;
			properties[fieldLabelMap[this.teacherLabel]] = this.teacher;
			properties[fieldLabelMap['Grade']] = this.grade;
			if(this.studentId && fieldLabelMap['Student ID']) {
				properties[fieldLabelMap['Student ID']] = this.studentId;
			}
			if(this.email && fieldLabelMap['Email']) {
				properties[fieldLabelMap['Email']] = this.email;
			}
			if(this.phoneNumber && fieldLabelMap['Phone Number']) {
				properties[fieldLabelMap['Phone Number']] = this.phoneNumber;
			}

			var me = this;
			$.plicAPI({
				method: 'projects/' + this.project.plicProjectId + '/subjects',
				type: 'POST',
				params: {
					subject: {
						properties: properties
					},
					photo_id: this.subject.id
				},
				success: function(data) {
					let subject = data.subject;

					$.proxyAjax({
						url: 'ajax/onSubjectCreated.php',
						data: {
							jobId: me.project.jobId,
							subject,
							subjectFields: me.project.template.subject_fields
						},
						type: 'POST',
						dataType: 'json',
						retryTimeouts: true,
						success: function() {
							me.moveSubjectPose();
						},
						// Subject is already created, so do not hard stop for this
						error: function() {
							me.moveSubjectPose();
						}
					});
					
				},
				error: function () {
					$.Alert('Error', 'Failed to add new subject');
					me.loading = false;
				}
			});
		},
		getFieldLabelMap: function() {
			if(this.fieldLabelMap) {
				return this.fieldLabelMap;
			}

			var fieldIdMap = $.SubjectManagement.createFieldMap(this.project.template);
			var fieldLabelMap = {};
			for(var id in fieldIdMap) {
				fieldLabelMap[fieldIdMap[id]] = id;
			}

			this.fieldLabelMap = fieldLabelMap;
			return fieldLabelMap;
		},
		moveSubjectPose: function() {
			var me = this;
			$.plicAPI({
				method: 'album-photo-assignments',
				params: {
					album_photo_assignment: {
						album_id: this.project.subjectAlbumId,
						photo_id: this.subject.id
					}
				},
				success: function() {
					var deletedAlbumId;
					if(me.viewingDenied) {
						deletedAlbumId = me.deniedSubjectAlbum.id;
					} else {
						deletedAlbumId = me.project.guestSubjectAlbum.id;
					}

					// Delete old one
					$.plicAPI({
						method: 'albums/' + deletedAlbumId + '/photos/' + me.subject.id,
						type: 'DELETE',
						accept: 'application/vnd.plic.io.v1+json',
						success: function() {
							me.$emit('removePending', me.subject);
							me.loading = false;
						},
						error: function() {
							$.Alert('Error', 'Failed to delete subject photo from anonymous upload list');
							me.loading = false;
						}
					});
				},
				error: function() {
					$.Alert('Error', 'Failed to add subject photo to new album');
					me.loading = false;
				}
			});
		},
		deny: function() {
			var me = this;
			$.Confirm('Delete subject', 'Are you sure you want to deny this subject?  This will be deleted and this action cannot be undone.', function() {
				me.loading = true;

				$.plicAPI({
					method: 'album-photo-assignments',
					params: {
						album_photo_assignment: {
							album_id: me.deniedSubjectAlbum.id,
							photo_id: me.subject.id
						}
					},
					success: function() {
						// Delete old one
						$.plicAPI({
							method: 'albums/' + me.project.guestSubjectAlbum.id + '/photos/' + me.subject.id,
							type: 'DELETE',
							accept: 'application/vnd.plic.io.v1+json',
							success: function() {
								me.$emit('removePending', me.subject);
								me.loading = false;
							},
							error: function() {
								$.Alert('Error', 'Failed to delete subject photo');
								me.loading = false;
							}
						});
					},
					error: function() {
						$.Alert('Error', 'Failed to add subject photo to new album');
						me.loading = false;
					}
				});
			});
		},
		zoom: function() {
			$.viewFullResolutionImage([this.subject], [this.name], {
				download: true
			});
		}
	},
	mounted: function() {
		$(this.$refs.zoomButton).popup({
			content: 'Click to view and download full resolution image'
		});
	},
	unmounted: function() {
		$(this.$refs.zoomButton).popup('destroy');
	}
};
</script>